import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ReferralPartnerRow from '../ReferralPartnerRow/ReferralPartnerRow';
import './ReferralPartner.css';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Row from 'react-bootstrap/Row';
import {QuestionCircle} from 'react-bootstrap-icons';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {Trash, Pencil, PencilFill} from 'react-bootstrap-icons';

function ReferralPartner() {
  const [partnersModal, setPartnersModal] = useState(false);
  const handlePartnersModal = () => {
    setPartnersModal(!partnersModal);
  }

  useEffect(() => {
    dispatch({ type: 'FETCH_REFERRALS' });
  }, []);

  // get the partner reducer
  const partners = useSelector((store) => store.referralPartnerReducer);
  const dispatch = useDispatch();

  const [referralName, setNewReferralName] = useState('');
  const [referralPhone, setNewReferralPhone] = useState('');
  const [referralCode, setNewReferralCode] = useState('');
  const [referralNameEdit, setNewReferralNameEdit] = useState(partners.name);
  const [referralPhoneEdit, setNewReferralPhoneEdit] = useState(partners.phone);
  const [referralCodeEdit, setNewReferralCodeEdit] = useState(partners.code);
  const [edit, setEdit] = useState(false);

  console.log(partners)
  function handleSubmit() {
    dispatch({
      type: 'ADD_REFERRAL_PARTNER',
      payload: {
        referralName: referralName,
        referralPhone: referralPhone,
        referralCode: referralCode.toUpperCase(),
      }
    });

    dispatch({ type: 'FETCH_REFERRALS' });
    setNewReferralName('');
    setNewReferralPhone('');
    setNewReferralCode('');

  }
  const handleEdit = () => {
    setEdit(true);
  }
  const handleExit = () => {
    setEdit(false);
  }
  function handleEditSubmit() {
    console.log(referralNameEdit)
    console.log(referralPhoneEdit)
    console.log(referralCodeEdit)
  }

  return (
    <>
                <Modal
                size="md"
                show={partnersModal}
                onHide={() => handlePartnersModal()}
                animation={false}
            >
                <Modal.Header>
                    <Modal.Title className="w-100 text-center">
                        INSTRUCTIONS
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                <p>In order to create a new referral partner, you must fill in the three input fields and press submit.</p> <p>Below
        the input boxes, a table displaying all referral partners is shown. You are able to delete a referral partner from
        the table by clicking on the delete button <Trash size={30} color="red" /><p><strong><em>* WARNING - This CANNOT be undone *</em></strong>.</p>You may also edit each referral partner's name, phone, and code by clicking
        the edit button <Pencil size={30}/>and subsequently pressing the save button <PencilFill size={30} />
           </p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button
                    variant="primary"
                    onClick={handlePartnersModal}
                    >CLOSE</Button>
                </Modal.Footer>
            </Modal>
       <Container fluid>
       <Row className="ml-3 mb-3"><h3 id="partnersHeader">PARTNERS</h3><QuestionCircle 
                        className="ml-2 py-1`"
                        type="button"
                        color="#d1a228" size={30}
                        onClick={handlePartnersModal}
                        /></Row>
        <form onSubmit={handleSubmit}>
          <div id='form-row' className="row d-flex justify-content-center">
            <div className="col-xs-2">
              <div className="form-group mr-3">
                <label htmlFor="name">Name*</label>
                <input required id="name" className="form-control" type="text" value={referralName} placeholder="Name" onChange={event => setNewReferralName(event.target.value)} ></input>
              </div>
            </div>

            <div className="col-xs-2">
              <div className="form-group mx-3">
                <label htmlFor="phone">Phone*</label>
                <input required id="phone" className="form-control " type="number" value={referralPhone} placeholder="Phone" onChange={event => setNewReferralPhone(event.target.value)} ></input>
              </div>
            </div>
            <div className="col-xs-2">
              <div className="form-group ml-3">
                <label htmlFor="code">Referral Code*</label>
                <input required id="code" className="form-control" type="text" value={referralCode} placeholder="Referral Code" onChange={event => setNewReferralCode(event.target.value)} ></input>
              </div>
            </div>
            <div className="col-xs-2">
              <div className="form-group">
                <Button variant="outline-primary" id='form-btn' size="sm" type="submit">SUBMIT</Button>
              </div>
            </div>
          </div>

        </form>


        <Table striped bordered hover>
          <thead>
            <tr>
              <th scope="col" className="text-center">Name</th>
              <th scope="col" className="text-center">Phone</th>
              <th scope="col" className="text-center">Referral Code</th>
              <th scope="col" className="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {partners.map((partner => {
              return (
                <ReferralPartnerRow
                  key={partner.id}
                  partner={partner}
                />
              )
            }))}
          </tbody>
        </Table>
      </Container>
    </>
  )
}
export default ReferralPartner